import * as Types from "../../../constants";
import produce from "immer";

let initialState = {
  supplier_keys: [],
  supplier_accounts: [],
  total: 0
};
export default (state = initialState, action = {}) => {
  return produce(state, draft => {
    switch (action.type) {
      case Types.GET_ALL_SUPPLIER_KEYS:
        draft.supplier_keys = action.suppliers.data;
        draft.total = action.suppliers.total;
        break;
        case Types.GET_ALL_SUPPLIER_ACCOUNTS:
          draft.supplier_accounts = action.supplier_accounts.data;
          draft.total = action.supplier_accounts.total;
          break;
      default:
        return state;
    }
  })

}

